import type { FC } from 'react';
import React, { useEffect, useRef } from 'react';
import { PhoneInput } from '@alfa-bank/site-phone-input';
import { getNumbersFromStr } from '@alfa-bank/site-form-helpers/text/get-numbers-from-str';

import { InputField } from '../input-field/input-field';

import type { TIsCaption, TIsError, TPhoneFieldsProps } from './models';
import { getButtonsListener, NUMBER_LENGTH } from './helpers';

export const PhoneField: FC<TPhoneFieldsProps> = ({
    analytics,
    caption,
    collectorData,
    name = 'phone',
    placeholder = 'Мобильный телефон',
    focusCaptions = ['Открыть счёт', 'Заполнить заявку'],
    focusExcludeAttributes = {},
    required = false,
    focusEvent,
}) => {
    const ref = useRef<HTMLInputElement>(null);

    useEffect(() => {
        const buttonsListener = getButtonsListener(
            focusCaptions,
            focusExcludeAttributes,
            ref,
            name,
            collectorData?.operatingSystemName
        );

        document.addEventListener('click', buttonsListener, false);

        return () => {
            document.removeEventListener('click', buttonsListener);
            // Тут нужен прокинуть id таймера и переписать код чтобы его сохранять
            // If the parameter provided does not identify a previously established action, this method does nothing.
            // Тоисть тут похоже сейчас бесконечные таймеры
            // @ts-ignore migration TS@4.4.4->4.9.5
            clearTimeout();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref, focusCaptions, focusExcludeAttributes, collectorData?.operatingSystemName]);

    const isErrorField: TIsError = field => {
        const { active, error, touched } = field.meta;

        if (getNumbersFromStr(field?.input.value).length === NUMBER_LENGTH && error) {
            return Boolean(error);
        }
        if (!active && touched && error) {
            return Boolean(error);
        }
    };

    const isCaptionField: TIsCaption = field => {
        const { active, error, touched } = field.meta;
        if (!active && touched && error) {
            return error;
        }
        if (getNumbersFromStr(field?.input.value).length !== NUMBER_LENGTH) return caption;

        return error ? error : caption;
    };

    return (
        <InputField
            ref={ref}
            analytics={analytics}
            focusEvent={focusEvent}
            isCaptionField={isCaptionField}
            isErrorField={isErrorField}
            required={required}
            type="phone"
        >
            <PhoneInput caption={caption} name={name} placeholder={placeholder} />
        </InputField>
    );
};
